import { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../context/LanguageContext';
import { Anchor } from 'lucide-react';

const CORRECT_PASSWORD = process.env.REACT_APP_WEDDING_PASSWORD;

export const PasswordGate = ({ children }) => {
  const { language, setLanguage, t } = useLanguage();
  const [password, setPassword] = useState('');
  const [remember, setRemember] = useState(false);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    const saved = localStorage.getItem('wedding_auth');
    if (saved === 'true') setIsAuthenticated(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps -- runs once on mount to check saved flag; setIsAuthenticated is a stable setter
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (password === CORRECT_PASSWORD) {
      setIsAuthenticated(true);
      if (remember) localStorage.setItem('wedding_auth', 'true'); // non-sensitive boolean flag only, not the password
    } else {
      setError(language === 'fr' ? 'Mot de passe incorrect' : 'Incorrect password');
    }
  };

  if (isAuthenticated) return children;

  return (
    <div className="min-h-screen bg-[#EFF4F9] flex flex-col items-center justify-center px-6" data-testid="password-gate">
      <div className="absolute top-6 right-6 flex items-center gap-1.5 text-sm">
        <button onClick={() => setLanguage('fr')}
          className={`px-3 py-1 rounded-full transition-all ${language === 'fr' ? 'bg-[#1E3A5F] text-white font-medium' : 'text-[#6B8299] hover:text-[#1A2B3D]'}`}
          data-testid="gate-lang-fr">FR</button>
        <button onClick={() => setLanguage('en')}
          className={`px-3 py-1 rounded-full transition-all ${language === 'en' ? 'bg-[#1E3A5F] text-white font-medium' : 'text-[#6B8299] hover:text-[#1A2B3D]'}`}
          data-testid="gate-lang-en">EN</button>
      </div>

      <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8 }}
        className="text-center max-w-sm w-full">
        <Anchor className="w-8 h-8 text-[#C9A96E] mx-auto mb-4" strokeWidth={1.5} />
        <h1 className="font-serif text-6xl sm:text-7xl text-[#1A2B3D] mb-4 font-light">A & T</h1>
        <p className="text-[#C9A96E] text-xs uppercase tracking-[0.3em] mb-2">October 10th, 2026</p>
        <p className="text-[#6B8299] text-sm mb-12">Annapolis, Maryland</p>

        <form onSubmit={handleSubmit} className="space-y-5 text-left">
          <input type="password" value={password}
            onChange={(e) => { setPassword(e.target.value); setError(''); }}
            placeholder={t('password')}
            className="w-full bg-transparent border-b border-[#CBD5E1] py-3 text-[#1A2B3D] placeholder-[#9BB0C4] focus:outline-none focus:border-[#1E3A5F] transition-colors text-base"
            data-testid="gate-password-input" />

          <p className="text-[#6B8299] text-xs text-center mt-2">
            {language === 'fr' ? 'Veuillez entrer le mot de passe pour continuer.' : 'Please enter the password to continue.'}
          </p>
          {error && <p className="text-red-400 text-xs text-center">{error}</p>}

          <button type="submit"
            className="w-full bg-[#1E3A5F] text-white py-3 text-sm tracking-wider hover:bg-[#2C5F7C] transition-colors rounded-sm mt-4"
            data-testid="gate-enter-button">
            {t('enter')}
          </button>
        </form>
      </motion.div>
    </div>
  );
};
